import {Button, Checkbox, CheckboxGroup, Dialog, FormControl, Textarea} from '@primer/react'
import {useState, type FormEventHandler, type RefObject} from 'react'
import type {FeedbackSubmitHandler} from './GroupsFeedback'
import type {ChangeGroupFeedbackOption} from '../../types/group-types'

interface NegativeFeedbackFormProps {
  onClose: () => void
  onSubmit: FeedbackSubmitHandler
  returnFocusRef?: RefObject<HTMLButtonElement | null>
  feedbackOptions: ChangeGroupFeedbackOption[]
  precheckOther?: boolean
}

export function NegativeFeedbackForm({
  onClose,
  onSubmit,
  returnFocusRef,
  feedbackOptions,
  precheckOther = false,
}: NegativeFeedbackFormProps) {
  const [dirty, setDirty] = useState(false)
  const [feedbackChoice, setFeedbackChoice] = useState<string[]>(precheckOther ? ['OTHER'] : [])
  const [textResponse, setTextResponse] = useState('')

  const handleSubmit: FormEventHandler = e => {
    e.preventDefault()
    setDirty(true)

    if (feedbackChoice.length) onSubmit({type: 'NEGATIVE', feedbackChoice, textResponse})
  }

  return (
    <Dialog
      onClose={onClose}
      title="Provide additional feedback"
      subtitle="Please help us improve Groups by Copilot by sharing more details about these generated groups."
      returnFocusRef={returnFocusRef}
      renderBody={() => (
        <form onSubmit={handleSubmit}>
          <Dialog.Body>
            <div className="mb-3">
              <CheckboxGroup onChange={setFeedbackChoice} required>
                <CheckboxGroup.Label>Category</CheckboxGroup.Label>
                {feedbackOptions.map(opt => (
                  <FormControl key={opt.value} id={`feedback_choice_${opt.value}`}>
                    <Checkbox value={opt.value} checked={feedbackChoice.includes(opt.value)} />
                    <FormControl.Label>{opt.label}</FormControl.Label>
                  </FormControl>
                ))}
                {dirty && !feedbackChoice.length && (
                  <CheckboxGroup.Validation variant="error">Please select a feedback category</CheckboxGroup.Validation>
                )}
              </CheckboxGroup>
            </div>
            <FormControl id="text_response">
              <FormControl.Label>How should we improve this response?</FormControl.Label>
              <Textarea
                block
                rows={2}
                wrap="wrap"
                name="text_response"
                value={textResponse}
                resize="vertical"
                onChange={e => setTextResponse(e.currentTarget.value)}
              />
            </FormControl>
          </Dialog.Body>
          <Dialog.Footer>
            <Button type="submit" disabled={dirty && (!textResponse || !feedbackChoice)}>
              Submit
            </Button>
          </Dialog.Footer>
        </form>
      )}
    />
  )
}
